import { AxiosRequestConfig, Method } from 'axios';

import axiosInstance from './axios';

interface RequestParams {
  method: Method;
  url: string;
  data?: unknown;
  contentType?: string; // New prop for content type
  config?: CustomAxiosRequestConfig; // Use the custom interface here
}

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  skipErrorMessage?: boolean;
  isContainHeader?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const apiRequest = async <T>({ method, url, data = null, contentType, config = {} }: RequestParams): Promise<any> => {
  // Set 'Content-Type' if provided, otherwise default to 'application/json' for certain methods
  if (!config.headers) {
    config.headers = {};
  }

  const jwtToken = localStorage.getItem('accessToken');

  if (jwtToken) {
    config.headers['Authorization'] = `Bearer ${jwtToken}`; // Include JWT token in the header
  }

  if (contentType) {
    config.headers['Content-Type'] = contentType;
  } else if (!config.headers['Content-Type'] && ['POST', 'PUT', 'PATCH'].includes(method)) {
    config.headers['Content-Type'] = 'application/json';
  }

  // Perform the request with the final configuration
  const response = await axiosInstance.request<T>({
    method,
    url,
    data,
    ...config,
    withCredentials: true,
    timeout: 120000,
  });

  // Return the response data and null for the error

  const customConfig = response.config as CustomAxiosRequestConfig;

  if (customConfig.isContainHeader) return response;

  return response.data;
};

export default apiRequest;
